import React, { useRef, useEffect } from "react";

import $ from "jquery";
import "../../assets/js/TypeEffect.js"


const Roletypes = () => {
    return (
        <div className="subtitle subtitle-typed" >
            <a href="#" className="typing-title typewrite" data-period="2000" data-type='["Web-Developer", "Backend Engineer", "Machine Learning Engineer", "Coder"]'>
                <span className="wrap"></span>
            </a>
        </div>
    );
}

export default Roletypes;